const status = {
    customer_task_import:[
        {
            id:0,
            label:'Pending',
            class: 'text-default'
        },
        {
            id:1,
            label:'Running',
            class: 'text-info'
        },
        {
            id:2,
            label:'Success',
            class: 'text-success'
        },
        {
            id:3,
            label:'Error',
            class: 'text-danger'
        }
    ]
}

export default {
    getStatus({itemStatus, type, html = true}) {
        const item = status[type]?.find(({id}) => id == itemStatus);
        return (html) ? `<span class="${item?.class}">${item?.label}</span>` : item?.label;
    }
};